(function () {
    'use strict';

    angular.module('app.search', ['ngCookies']);
})();